import { TEMAS } from "../pages/EventoPublico/templates";
import { getRsvpCssVars, getRsvpTheme } from "../utils/rsvpTheme";
import RsvpClosedState from "./RsvpClosedState";

const label = { display: "block", marginBottom: 6, fontWeight: 600, color: "inherit", fontSize: 14 };
const input = {
  width: "100%", padding: "10px 12px", border: "2px solid #ddd", borderRadius: 8,
  fontSize: 15, background: "white", boxSizing: "border-box", fontFamily: "inherit",
  outline: "none", color: "#333",
};

export default function MockRsvpForm({
  templateId = "original",
  layoutConfig = null,
  previewMode = "form",
  closedDeadline = "2026-04-23T22:00:00",
}) {
  const temaBase = TEMAS[templateId] || TEMAS.original;
  const tema = getRsvpTheme(temaBase, layoutConfig);
  const peopleTheme = tema.people ?? {};
  const messageTheme = tema.message ?? {};

  if (previewMode === "closed") {
    return (
      <div style={{ fontFamily: "'Poppins', sans-serif", ...getRsvpCssVars(tema), color: tema.formTextColor ?? "inherit" }}>
        <RsvpClosedState theme={tema} deadline={closedDeadline} />
      </div>
    );
  }

  return (
    <div style={{ fontFamily: "'Poppins', sans-serif", ...getRsvpCssVars(tema), color: tema.formTextColor ?? "inherit" }}>
      {/* Seção pessoas */}
      <div style={{
        background: peopleTheme.sectionBg ?? tema.sectionBg,
        borderRadius: 15,
        padding: 20,
        marginBottom: 20,
        color: peopleTheme.textColor ?? tema.labelColor,
        fontFamily: peopleTheme.fontFamily ?? undefined,
      }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
          <span style={{
            ...tema.titulo,
            color: peopleTheme.titleColor ?? tema.titulo?.color,
            fontFamily: peopleTheme.fontFamily ?? tema.titulo?.fontFamily,
            fontWeight: 600,
            fontSize: "1.1em",
          }}>
            👥 Confirmar Pessoas
          </span>
          <span style={{
            padding: "8px 16px",
            borderRadius: 20,
            fontWeight: 600,
            fontSize: 14,
            ...tema.btnAdd,
            ...peopleTheme.addButton,
          }}>
            + Adicionar
          </span>
        </div>

        <div style={{ background: peopleTheme.itemBg ?? tema.itemBg, borderRadius: 12, padding: 20, boxShadow: "0 3px 10px rgba(0,0,0,0.1)" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 15 }}>
            <div style={{
              background: peopleTheme.numberBg ?? tema.numeroBg,
              color: peopleTheme.numberColor ?? tema.numeroColor,
              width: 30, height: 30, borderRadius: "50%",
              display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 600, fontSize: 14,
            }}>
              1
            </div>
          </div>

          <div style={{ display: "flex", flexWrap: "wrap", gap: 15 }}>
            <div style={{ flex: "2 1 160px", minWidth: 0, marginBottom: 12 }}>
              <label style={{ ...label, color: peopleTheme.textColor ?? tema.labelColor }}>👤 Nome</label>
              <input className="rsvp-themed-field rsvp-people-field" type="text" placeholder="Nome completo" style={{ ...input, ...tema.inputExtra, ...peopleTheme.input }} readOnly />
            </div>
            <div style={{ flex: "1 1 100px", minWidth: 0, marginBottom: 12 }}>
              <label style={{ ...label, color: peopleTheme.textColor ?? tema.labelColor }}>👶 É Criança</label>
              <select className="rsvp-themed-field rsvp-people-field" style={{ ...input, ...tema.inputExtra, ...peopleTheme.input }} defaultValue="nao" disabled>
                <option value="nao">Não</option>
                <option value="sim">Sim</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      {/* Seção recado */}
      <div style={{
        background: messageTheme.sectionBg ?? tema.recadoBg,
        borderRadius: 15,
        padding: 20,
        marginBottom: 20,
        color: messageTheme.textColor ?? tema.sectionTitleColor ?? tema.labelColor,
        fontFamily: messageTheme.fontFamily ?? undefined,
      }}>
        <label style={{
          ...label,
          color: messageTheme.titleColor ?? tema.sectionTitleColor ?? tema.labelColor,
          fontFamily: messageTheme.fontFamily ?? undefined,
        }}>💌 Recado (opcional):</label>
        <textarea
          className="rsvp-themed-field rsvp-message-field"
          placeholder="Deixe um recado carinhoso..."
          rows={3}
          readOnly
          style={{ ...input, ...tema.inputExtra, ...messageTheme.input, resize: "vertical", minHeight: 80 }}
        />
      </div>

      <button type="button" disabled style={{
        padding: "16px 30px",
        border: "none",
        borderRadius: 25,
        cursor: "default",
        fontSize: 17,
        fontWeight: 600,
        width: "100%",
        textTransform: "uppercase",
        letterSpacing: 1,
        ...tema.submit,
      }}>
        Confirmar Todas as Presenças
      </button>
    </div>
  );
}
